import { getConfig } from '@cian/config/browser';
import { createReduxStore } from '../../../shared/utils/redux';
import { IApplicationState } from '../../../shared/types/redux';
import { IApplicationContext } from '../../../shared/types/application';

export function createApplicationState(context: IApplicationContext) {
  const config = getConfig();

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, context);
}
